import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { GET, POST, POST_JSON } from "../../ConsumeApiController";
import { api } from "../../ConsumeApiController";

export async function getAttributeValues(attributeId)
{
    const response = await GET(CompanyRoutes.Products.Attributes.Values.getAll+`${attributeId}/attribute-values`);

    return response;
}

export async function createAttributeValue(attributeId,value,description)
{
    const route = CompanyRoutes.Products.Attributes.Values.create+`${attributeId}/attribute-values`
    const body = {value,description};
    const response = await api.post(route,body); 

    return response;
}

export async function getAttributeValue(attributeValueId)
{
    const response = await GET(CompanyRoutes.Products.Attributes.Values.show+`${attributeValueId}`);

    return response;
}

export async function updateAttributeValue(attributeValueId,value,description)
{
    const route = CompanyRoutes.Products.Attributes.Values.update+`${attributeValueId}`;
    console.log('USANDO LA RUTA ===> ',route);
    const body = {value,description};
    const response = await api.put(route,body); 

    return response;
}

export async function deleteAttributeValue(attributeValueId)
{
    const response = await api.delete(CompanyRoutes.Products.Attributes.Values.delete+`${attributeValueId}`);

    return response;
}